export default __webpack_public_path__ + "static/newsletter-a3a5946cf3bd16a143cf9b6a881f24e0.jpg";